<template>
  <div class="container-fluid ">
    <h1 class="detail-title" >
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Invite Users
    </h1>
    <div id="card">
      <div class="card-section">
        <div class="row section-body user" v-for="(layout, index) in inviteUserLayout">
          <div class="col-sm-2 section-property-block sub-section" v-for="field in layout">
            <p class="section-property-title">{{ field }}</p>
            <p v-if="field != 'Organization'">
              <input :name="field +'-'+ index" class="section-property" type="text" :disabled="false">
            </p>
            <p v-else>
              <select class="section-property" :name="field +'-'+ index">
                <option value=""></option>
                <option v-for="organization in organization_options"
                    :value="organization.id">{{ organization.name }}
                </option>
              </select>
            </p>
          </div>
          <div :class="['col-sm-1', 'section-property-block', 'add', {changeButton:changeButton(index)}]">
            <div class="plus" @click="addUser(index)">
              <img src="../../assets/plus.svg" alt="">
            </div>
          </div>
          <div :class="['col-sm-1', 'section-property-block', {changeButton:changeButton(index)}]">
            <div class="plus remove" @click="RemoveUser(index)">
              <img src="../../assets/letter-x.svg" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="invite()">Invite Users</btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import GenericUpdateCreate from '../../api';
import store from '../../store.js';
import Vue from 'vue';
import { validateEmail }  from '../../utils';

export default{
    props: {
    },
    data: function(){
      return {
        inviteUserLayout: [['First Name', 'Last Name', 'Email', 'Organization']],
        organizations: [],
        users: []
      };
    },
    computed: {
      ...mapState({
        organization_options: function(state) {
          return store.state.organizations;
        },
        errors: function(state){
          return store.state.errors;
        }
      }),

      inviteUserLayoutLength: function () {
        return this.inviteUserLayout.length;
      }
    },
    methods: {
      toggleSidebar(){
        bus.$emit('toggle-sidebar');
      },
      
      showNotification (type, content) {
        this.$notify({
          type: type,
          content: content
        });
      },
      invite: async function () {
        store.dispatch('resetErrors');
        let users = [];
        let data = {}
        let response = null;
        let empty = 0;
        let _this = this;
        $('.user').each(function(i, obj) {
          let field, name;
          let position = 0;
          $('input[type=text], select').each(function(){
             field = $(this).attr('name').split('-');
             name = _.snakeCase(field[0]);
             position = field[1];
             let a = 'All fields must contain data.';
             try {
                  if (name === 'email') {
                    if ( !validateEmail($(this).val()) ) _this.errors.push('Please enter a valid email');
                  }
                  if (!data.hasOwnProperty(position)){
                    data[position] = {};
                  }
                  data[position][name] = $(this).val();
                  
                  console.log("Just checking validity... ", validateEmail($(this).val()));
                  console.log("I wanna see all your colors 2: ", data[position]);  
              } catch (e) {
                 if (!_this.errors.includes(a)) {
                  _this.errors.push(a);
                 }
                empty++;
                // data[position] = {};
                // data[position][name] = $(this).val()
                console.log("Error: ",e);
                return;
             }
          });
        });
        if (this.errors.length > 0) {
          // show notification and process no more
          for (let error of _this.errors){
            this.showNotification('warning', error);
          }
          return;
        }

        //populate list of users
        for (var key in data) {
          if (data.hasOwnProperty(key) && data[key] !== "") {
            console.log(key, data[key]);
            users.push(data[key]);
          } else {console.log("I can't do anything without data. You Get me?")}
        }

        if (empty === 0) {
          response = await PortalUser.inviteUsers(users);
          console.log('RESPONSE ', response);
          if (response !== undefined && response !== null) {
            if (response.hasOwnProperty('errors')){
              this.showNotification('danger', response.errors);
            } else {
              this.showNotification('success', 'Invites successfully sent.');
              this.$router.push('/users');
            }
          }else{
            this.showNotification('danger', 'An error occured while attempting to invite users.');
          }
        }else {
           _this.showNotification('warning', 'All fields must be completed before sending invite.');
        }

        this.users = [];
      },
      changeButton: function (index) {
        return index === 0 ? false : true;
      },
      addUser: function () {
       this.inviteUserLayout.push(['First Name', 'Last Name', 'Email', 'Organization']);
      },
      RemoveUser: function () {
        if (this.inviteUserLayoutLength > 1) {
          this.inviteUserLayout.pop();
        }
      },
    },
    
    beforeRouteEnter (to, from, next) {
      let organizations = store.state.organizations;
      if(organizations && organizations.length < 1)
        store.dispatch('fetchAllOrganizations');
      next();
    }
};
</script>

<style scoped lang="scss">
@import "../../css/constants";
input, textarea, select { outline: none; border: none; }

input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  border-bottom: 1px solid #c3c3c3;
}

h1.detail-title{
    background-color: #55bafc;
    padding: 20px;
    margin-left: -40px;
    margin-right: -40px;
    color: white;
    height: auto;
    margin-bottom: 25px;
}

/* body select.select_box */
select {
  height: 20px !important;
  display: block;
  padding: 6px 0px !important;
  max-width: 100%;
  height: auto !important;
  border: none !important;
  border-radius: 0px;
  background: transparent;
  border-bottom: 1px solid #c3c3c3 !important;

  overflow: auto;

  font-size: 16px;
  line-height: 16px !important;
  appearance: none; /* this is must */
  -webkit-appearance: none;
  -moz-appearance: none;
}

.section-property:hover{
  display: block;
}
.card-section {
  display: flex;
  flex-direction: column;
}
.section-body {
  display: flex;
  flex-wrap: wrap;
}
.section-title {
    color: $gray7;
    font-size: $p20;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
  margin-bottom: $p16;
  // min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: $p14;
    line-height: $p14;
}
.section-property {
    color: $gray7;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}

//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
}
.plus > img{
  margin: auto;
}
.changeButton{
 display: none;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
  
@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  .col-sm-1 {
    width: 3.333333%;
  }
  
  h1.detail-title {
    padding-left: 45px;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px;  }
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px; }
  } 
}

</style>



// WEBPACK FOOTER //
// src/components/user/InviteUser.vue